import { useEffect, useState } from "react";
import { IEditCatalogo } from "../../../../../Interfaces/hazard/IHazard";
import { IPanelEditarCatalogo } from "./PanelEditarCatalogo";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { CatalogoInseguroService } from "../../../../../services/hazard/catalogoInseguroService";

export const UsePanelEditarCatalogo=(props:IPanelEditarCatalogo)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:IEditCatalogo={
        nombreCatalogo: "",
        catalogoInseguroId: "",
    }
    const [request,setRequest]=useState<IEditCatalogo>(initial)
    const reset=()=>{
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    useEffect(()=>{
        if(props.isOpen){
          setRequest({...request,nombreCatalogo:props.item.nombreCatalogoInseguro,catalogoInseguroId:props.item.catalogoInseguroId})
          }
    },[props.isOpen])
    const putEditarCatalogo=()=>{
        setLoading(true)
        CatalogoInseguroService.ActualizarCatalogo(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status}

}